/* ══════════════════════════════════════════════
   ANTEI — Theme JavaScript
   Shopify Custom Theme v1.0
   ══════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── CART ── */
  const Cart = {
    drawer: null,
    overlay: null,
    countEl: null,

    init() {
      this.drawer = document.getElementById('cart-drawer');
      this.overlay = document.getElementById('cart-overlay');
      this.countEl = document.querySelector('.bag-count');
      this.fetch();
    },

    open() {
      this.drawer?.classList.add('open');
      this.overlay?.classList.add('open');
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.drawer?.classList.remove('open');
      this.overlay?.classList.remove('open');
      document.body.style.overflow = '';
    },

    async fetch() {
      try {
        const r = await fetch('/cart.js');
        const cart = await r.json();
        this.render(cart);
      } catch(e) { console.error('Cart fetch error', e); }
    },

    async add(variantId, quantity = 1) {
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        if (!r.ok) throw new Error('Add to cart failed');
        await this.fetch();
        this.open();
        Toast.show('Aggiunto al carrello');
      } catch(e) {
        Toast.show('Errore — riprova');
        console.error(e);
      }
    },

    async change(key, quantity) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        await this.fetch();
      } catch(e) { console.error(e); }
    },

    render(cart) {
      // Update count badge
      const count = cart.item_count;
      if (this.countEl) {
        this.countEl.textContent = count;
        this.countEl.dataset.count = count;
        this.countEl.style.display = count > 0 ? 'inline-flex' : 'none';
      }

      // Update drawer
      const body = document.getElementById('cart-items');
      const empty = document.getElementById('cart-empty');
      const foot = document.getElementById('cart-foot');
      const totalEl = document.getElementById('cart-total-price');

      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '';
        if (empty) empty.style.display = 'block';
        if (foot) foot.style.display = 'none';
      } else {
        if (empty) empty.style.display = 'none';
        if (foot) foot.style.display = 'block';
        if (totalEl) totalEl.textContent = ANTEI.formatMoney(cart.total_price);

        body.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <div class="cart-item-img">
              ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
            </div>
            <div>
              <div class="cart-item-name">${item.product_title}</div>
              <div class="cart-item-meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''} / Qty ${item.quantity}</div>
              <button class="cart-item-remove" data-key="${item.key}">Rimuovi</button>
            </div>
            <div class="cart-item-price">${ANTEI.formatMoney(item.final_line_price)}</div>
          </div>
        `).join('');

        // Remove buttons
        body.querySelectorAll('.cart-item-remove').forEach(btn => {
          btn.addEventListener('click', () => this.change(btn.dataset.key, 0));
        });
      }
    }
  };

  /* ── TOAST ── */
  const Toast = {
    el: null,
    timer: null,
    init() { this.el = document.getElementById('toast'); },
    show(msg, duration = 2200) {
      if (!this.el) return;
      this.el.textContent = msg;
      this.el.classList.add('show');
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.el.classList.remove('show'), duration);
    }
  };

  /* ── SIZE SELECTOR ── */
  function initSizeSelector(container) {
    if (!container) return;
    container.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        container.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
      });
    });
  }

  /* ── QUANTITY ── */
  function initQty(wrapper) {
    if (!wrapper) return;
    const input = wrapper.querySelector('.qty-input');
    wrapper.querySelector('.qty-minus')?.addEventListener('click', () => {
      const v = parseInt(input.value) - 1;
      input.value = Math.max(1, v);
    });
    wrapper.querySelector('.qty-plus')?.addEventListener('click', () => {
      const v = parseInt(input.value) + 1;
      input.value = Math.min(10, v);
    });
  }

  /* ── PRODUCT FORM (ATC) ── */
  function initProductForm(form) {
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const sizeBtn = form.querySelector('.size-btn.selected');
      const variantId = sizeBtn ? sizeBtn.dataset.variantId : form.querySelector('[name="id"]')?.value;
      if (!variantId) { Toast.show('Seleziona una taglia'); return; }
      const qty = parseInt(form.querySelector('.qty-input')?.value || 1);
      const btn = form.querySelector('.btn-primary');
      if (btn) { btn.textContent = '...'; btn.disabled = true; }
      await Cart.add(variantId, qty);
      if (btn) { btn.textContent = 'Aggiungi al carrello'; btn.disabled = false; }
    });
  }

  /* ── PRODUCT GALLERY ── */
  function initGallery() {
    const main = document.querySelector('.pd-main img');
    const thumbs = document.querySelectorAll('.pd-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.dataset.src;
        const newAlt = thumb.dataset.alt;
        if (newSrc) {
          main.src = newSrc;
          if (newAlt) main.alt = newAlt;
        }
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  /* ── FORMAT MONEY ── */
  window.ANTEI = window.ANTEI || {};
  ANTEI.formatMoney = function(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  };

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    Toast.init();
    Cart.init();
    initSizeSelector(document.querySelector('.sizes'));
    initQty(document.querySelector('.qty-row'));
    initProductForm(document.querySelector('.product-form'));
    initGallery();

    // Cart drawer toggle
    document.querySelector('.hdr-bag')?.addEventListener('click', () => Cart.open());
    document.getElementById('cart-overlay')?.addEventListener('click', () => Cart.close());
    document.querySelector('.cart-close')?.addEventListener('click', () => Cart.close());

    // Cart checkout button
    document.querySelector('.cart-checkout-btn')?.addEventListener('click', () => {
      window.location.href = '/checkout';
    });

    // Product card ATC buttons
    document.querySelectorAll('.product-card-atc').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) { Toast.show('Vedi prodotto per scegliere la taglia'); return; }
        await Cart.add(variantId);
      });
    });

    // Homepage quick-add ATC
    document.querySelector('.fd-atc')?.addEventListener('click', async function() {
      const sizeBtn = document.querySelector('#fd-sizes .size-btn.selected');
      const variantId = sizeBtn?.dataset.variantId || this.dataset.defaultVariant;
      if (!variantId) { Toast.show('Seleziona una taglia'); return; }
      await Cart.add(variantId);
    });

    // Ticker pause on hover already in CSS
  });

})();
